import {GET_NOTICE, UPDATE_NOTICE} from './type'

export function getUserNotification(user_id = null){
    return function(dispatch, getState, {axios}){
        const params = {};
        if (user_id) {
            params.user_id = user_id
        }
        axios.get(`/user_notification`, {
            params
        })
        .then((response) => {
            dispatch({
                type: GET_NOTICE,
                payload: response.data
            });
        })
        .catch((err) => {
            dispatch({
                type: GET_NOTICE,
                payload: {data: [], count: 0, orderCount: 0}
            });
        })
    }
}

export function updateUserNotification(user_id = null){
    return function(dispatch, getState, {axios}){ 
        dispatch({
            type: UPDATE_NOTICE,
            payload: null
        });
        axios.post('/update_notice', {
            user_id
        })
        .then((response) => {
            dispatch({
                type: UPDATE_NOTICE,
                payload: true
            });
        })
        .catch((error) => {
            dispatch({
                type: UPDATE_NOTICE,
                payload: false
            })
        })
    }
}